import { Button } from "@/lib/components/Button/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/lib/components/Dialog";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { useNavigate, useParams } from "react-router";
import { paths } from "@/App";
import { useState } from "react";
import Toast from "@/lib/components/Toast";

export default function DeleteVideoDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
}) {
  const navigate = useNavigate();
  const { teamExternalId } = useParams();
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteVideo = useEditorStore((state) => state.service.deleteVideo);
  const videoName = useEditorStore((state) => state.video?.name);

  const handleDelete = async () => {
    if (isDeleting) return;

    setIsDeleting(true);

    try {
      const video = await deleteVideo();

      if (!video?.deletedAt) {
        Toast.error("Video could not be deleted");
        return;
      }

      Toast.info("Video deleted successfully");
      onOpenChange(false);
      navigate(paths.videos(teamExternalId!));
    } catch (error) {
      console.error("Failed to delete video:", error);
      Toast.error("Failed to delete video");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader className="w-full">
          <DialogTitle>Delete Video</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the video
            {videoName && (
              <>
                {" "}
                <span className="font-semibold">{videoName}</span>
              </>
            )}
            ?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-0">
          <Button onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
          <DialogClose asChild>
            <Button type="button" variant="outline" disabled={isDeleting}>
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
